import loadAsync from "routing/loadAsync";
const HostActivity = loadAsync(() => import("security-app/pages/HostActivity"));
const NetworkActivity = loadAsync(() => import("security-app/pages/NetworkActivity"));
const Overview = loadAsync(() => import("security-app/pages/Overview"));
const UserActivity = loadAsync(() => import("security-app/pages/UserActivity"));
const ActivityPage = loadAsync(() => import("security-app/pages/ActivityPage"));
const Sigma = loadAsync(() => import("security-app/pages/sigma/Sigma"));
const SigmaConfig = loadAsync(() => import("security-app/pages/sigma/SigmaConfig"));
const DetectorConfiguration = loadAsync(() => import("security-app/pages/anomaly/DetectorConfiguration"));
const Investigations = loadAsync(() => import("security-app/pages/investigations/Investigations"));
const InvestigationDetails = loadAsync(() => import("security-app/components/Investigations/Details"));
const InvestigationsConfig = loadAsync(() => import("security-app/pages/investigations/InvestigationsConfig"));
const AssetsList = loadAsync(() => import("security-app/pages/assets/AssetsList"));
const AssetsConfig = loadAsync(() => import("security-app/pages/assets/AssetsConfig"));
const AssetSources = loadAsync(() => import("security-app/pages/assets/AssetSourcesList"));
const AssetSourcesForms = loadAsync(() => import("security-app/pages/assets/AssetSourceForms"));
const SecurityOverviewPage = loadAsync(() => import("security-app/pages/Welcome/SecurityOverviewPage"));
const VulnerabilityScanners = loadAsync(() => import("security-app/pages/assets/AssetsVCList"));
export {
  DetectorConfiguration,
  HostActivity,
  NetworkActivity,
  Overview,
  UserActivity,
  ActivityPage,
  Sigma,
  SigmaConfig,
  Investigations,
  InvestigationDetails,
  InvestigationsConfig,
  AssetsList,
  AssetsConfig,
  AssetSources,
  AssetSourcesForms,
  SecurityOverviewPage,
  VulnerabilityScanners
};
